"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToAtMostTwoDecimals = roundToAtMostTwoDecimals;
function roundToAtMostTwoDecimals(n) {
    return Number(`${Math.round((n + 'e2'))}e-2`);
}
//# sourceMappingURL=number-utils.js.map